import UserDto from '@/models/Users/UserDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import PersonDto from '@/models/Shared/Person';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import AgencyUserStatus from '@/models/AgencyUsers/AgencyUserStatus';

export default class AgencyUserDto extends BaseAgencyScopeEntityDto {
    status: AgencyUserStatus = AgencyUserStatus.Active;
    userId: string;
    user: UserDto = new UserDto();
    person: PersonDto = new PersonDto();
    emailAddress: string;
    mobilePhoneNumber: string;
    otherPhoneNumber: string;
    defaultDeskId: string;
    defaultDesk: DeskDto = new DeskDto();
    defaultBranchId: string;
    defaultBranch: BranchDto = new BranchDto();
    isAdministrator: boolean;
    avatar: string;
    managerId: string;
    manager: AgencyUserDto;
}